module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0022.jpg?v=bf473556";